import * as yup from 'yup';

export const checkoutMailValidation = yup.object().shape({
    email: yup
        .string()
        .email('Ingresa un email con formato válido, por ejemplo: nombre@ejemplo.com')
        .min(1)
        .required('Ingresa un email con formato válido, por ejemplo: nombre@ejemplo.com')
})